import { render, staticRenderFns } from "./Carwash.vue?vue&type=template&id=2417d54a&"
import script from "./Carwash.vue?vue&type=script&lang=js&"
export * from "./Carwash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports